
import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import MasterSettingAgreement36Form from 'components/organismos/master/MasterSettingAgreement36Form';

const MasterSettingAgreement36Page = () => (
    <SidebarTemplate pageTitle="顔写真登録">
        <MasterSettingAgreement36Form/>
    </SidebarTemplate>
);

export default MasterSettingAgreement36Page;
